import { useEffect, useState } from 'react';
import MessagingWorkspace from '@/components/messaging/MessagingWorkspace';
import { clientAPI } from '@/services/api';

const ClientMessages = () => {
  const [contacts, setContacts] = useState([]);
  useEffect(() => { clientAPI.getMessagingContacts().then((result) => setContacts(result.data || [])).catch(() => {}); }, []);
  return <MessagingWorkspace role="client" title="Messages" description="Keep BRM conversations and campaign context together." contacts={contacts}/>;
};

export default ClientMessages;
